/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'zoomIn': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g fill-rule="nonzero" _fill="none"><circle pid="0" _fill="#8300BF" cx="12" cy="12" r="12"/><path pid="1" d="M10.5 3a6.5 6.5 0 015.249 10.335l4.249 4.248-1.415 1.415-4.248-4.25A6.5 6.5 0 1110.5 3zm0 2a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm1 2v1.5H13v2h-1.5V12h-2v-1.5H8v-2h1.5V7h2z" _fill="#FFF"/></g>'
  }
})
